// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  API_URL: "https://api-dev.box593.com/app_dev.php/",
//  API_URL: "http://localhost/box593-api/web/app_dev.php/",

  CHAT_URL: "wss://api.box593.com/wss2/",
  TIA_PAYMENT_WIDGET_URL: 'https://test.oppwa.com/v1/paymentWidgets.js'
};



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/tia-box-dev/src/environments/environment.ts